import React, { useEffect, useRef, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import styles from "./CartDataRepurchase.module.css";
import "../../../fonts/Futura-PT-Book.ttf";

import paypaynew from "../../../assets/images/paypaynew.png";
import amazonpay from "../../../assets/images/amazonpay.png";
import rpay from "../../../assets/images/rpay.png";
import { useLocation, useNavigate } from "react-router-dom";
import useAxios from "../../Hooks/useAxios";
const CartDataRepurchase = () => {
  const { numberOfItems, totalPrice, itemIds } = useLocation().state;
  console.log(itemIds);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const axios = useAxios();
  const firstDivRef = useRef(null);
  const secondDivRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showProducts, setShowProducts] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const subPrices = [
    { text: "商品合計金額", price: totalPrice },
    { text: "送料", price: 0 },
  ];

  const paymentOptions = [
    {
      name: "クレジットカード",
    },
    {
      name: "PayPay",
      imageSrc: paypaynew,
      subtext: "PayPayでお支払いができます。",
      iconStyle: "payment_icon01",
    },
    {
      name: "楽天PAY",
      imageSrc: rpay,
      subtext: "楽天IDでお支払いができます。",
      iconStyle: "payment_icon02",
    },
    {
      name: "Amazonペイ",
      imageSrc: amazonpay,
      subtext: "Amazonアカウントでお支払いができます。",
      iconStyle: "payment_icon03",
    },
    {
      name: "銀行振込",
      label: "銀行振込",
      subtext: "振込確認後、アイテム編集が可能となります。ご了承下さい。",
    },
  ];

  const handlePaymentMethodChange = (methodName) => {
    setPaymentMethod(methodName);
  };

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  useEffect(() => {
    const firstDivRight = firstDivRef.current.getBoundingClientRect().right;
    secondDivRef.current.style.left = `${firstDivRight + 36}px`;
  }, [windowWidth]);

  const confirmOrder = () => {
    if (paymentMethod.length === 0) {
      alert("Please Select a payment method");
    } else {
      const data = {
        annual_pass_ids: itemIds,
        payment_method: paymentMethod,
        amount: totalPrice,
      };
      console.log("Trying to confirm order", data);
      navigate("/purchase-success", {
        state: { paymentMethod: paymentMethod, fromRepurchase: true },
      });
      // axios
      //   .post(
      //     backend_base + "/maintenance/annual-pass/re-purchase/confirm",
      //     data
      //   )
      //   .then((res) => {
      //     if (res.status === 201 || res.status === 200) {
      //       console.log("Success Order");
      //       console.log(res.data);
      //       navigate("/purchase-success", {
      //         state: { paymentMethod: paymentMethod, fromRepurchase: true },
      //       });
      //     } else {
      //       console.log("Failed");
      //     }
      //   })
      //   .catch((e) => {
      //     alert(e.message);
      //   });
    }
  };

  return (
    <>
      <Header />
      <div className={styles.cart_details_main}>
        <div className={styles.fixed_price_box_main} ref={secondDivRef}>
          <div className={styles.fixed_price_box01}>
            <div
              style={{
                backgroundColor: "#f4f4f4",
                borderRadius: "9px",
                padding: "20px 30px",
              }}
            >
              <div className={styles.fixed_price_sub_main}>
                {subPrices.map((item, index) => {
                  return (
                    <div key={index} className={styles.subprice_single_row}>
                      <div className={styles.subprice_single_row_text}>
                        {item.text}
                      </div>
                      <div className={styles.subprice_single_row_price}>
                        {new Intl.NumberFormat("ja-JP", {
                          style: "currency",
                          currency: "JPY",
                        }).format(item.price)}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className={styles.fixed_price_01_divider}></div>
              <div className={styles.fixed_price_01_total_main}>
                <div className={styles.fixed_price_01_total_main_row}>
                  <div className={styles.fp_price_text}>商品合計</div>
                  <div className={styles.fp_price_total}>
                    {new Intl.NumberFormat("ja-JP", {
                      style: "currency",
                      currency: "JPY",
                    }).format(totalPrice)}
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                paymentMethod.length > 0
                  ? confirmOrder()
                  : alert("支払い方法を追加選択する必要があります。");
              }}
              className={styles.button01}
            >
              注文を確定する
            </div>
            <button
              onClick={() => navigate("/gallery-data-repuchase")}
              className="btn btn-outline-primary"
              style={{
                width: "97px",
                height: "40px",
                borderRadius: "22px",
                margin: "33px 0",
              }}
            >
              戻る
            </button>
          </div>
        </div>
        <div className={styles.heading01}>ご注文内容の確認</div>
        <div className={styles.heading02}>※ご注文はまだ確定していません</div>
        <div className={styles.body_main}>
          <div className={styles.address_payment_section} ref={firstDivRef}>
            <div className={styles.address_box_wrapper}>
              <div className={styles.address_box_top_main}>
                <div className={styles.heading03}>配送先の指定</div>
              </div>
              <div className={styles.address_box_main}>
                <table>
                  <tbody>
                    <tr className={styles.tableBody}>
                      <td>撮影データ再購入</td>
                      <td>
                        <span>個数</span>
                        <span className="ml-2">{numberOfItems}</span>
                      </td>
                      <td>
                        {new Intl.NumberFormat("ja-JP", {
                          style: "currency",
                          currency: "JPY",
                        }).format(totalPrice)}
                      </td>
                    </tr>
                    <tr className={styles.totalSection}>
                      <td></td>
                      <td className={styles.totalText}>商品合計</td>
                      <td className={styles.totalAmount}>
                        {new Intl.NumberFormat("ja-JP", {
                          style: "currency",
                          currency: "JPY",
                        }).format(totalPrice)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className={styles.payment_header}>お支払い方法</div>
            <div className={styles.payment_wrapper}>
              <div className={styles.payment_main_div}>
                <div className={styles.payment_main_div}>
                  {paymentOptions.map((option, index) => (
                    <PaymentOption
                      key={index}
                      name={option.name}
                      imageSrc={option.imageSrc}
                      subtext={option.subtext}
                      iconStyle={option.iconStyle}
                      handlePaymentMethodChange={handlePaymentMethodChange}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.dummy_div01}></div>
        </div>
        <div className={styles.bottom_space}></div>
      </div>
      <Footer />
    </>
  );
};

const PaymentOption = ({
  name,
  imageSrc,
  subtext,
  iconStyle,
  handlePaymentMethodChange,
}) => {
  return (
    <div className={styles.payment_row}>
      <div className={styles.payment_row_first_main}>
        <input
          className={styles.radio}
          type="radio"
          name={"paymentmethod"}
          value={name}
          onChange={(e) => {
            handlePaymentMethodChange(e.target.value);
          }}
          onClick={(event) => {}}
        />
        <div className={styles.row_radio_text}>{name}</div>
      </div>
      <div className={styles.payment_row_second_main}>
        {imageSrc && (
          <img src={imageSrc} className={styles[iconStyle]} alt="img" />
        )}
        <div className={styles.row_payment_subtext}>{subtext}</div>
      </div>
    </div>
  );
};

export default CartDataRepurchase;
